<ng-container *transloco="let t">
  <div class="container"></div>
  @if (isLanding && isTopBannerVisible) {
    <app-top-banner/>
  }

  <header class="header d-flex align-items-center fixed-top {{ additionalClass }}"
          [ngClass]="{ 'fixed-top--with-banner': isLanding && isTopBannerVisible, 'landing': isLanding }">

    <div class="mobile-search-wrapper d-flex align-items-center justify-content-center w-100 d-xxl-none" [@searchSlideInOut]="isSearchVisible ? 'visible' : 'hidden'"
         [ngClass]="{ 'mobile-search-wrapper--with-banner': isTopBannerVisible }">
      <div class="d-flex justify-content-center align-items-center w-100 px-3">
        <app-search-bar-events [isTransparent]="true"/>
      </div>
    </div>
    <div class="container py-0 navigation container--header">
      <div class="d-flex flex-wrap justify-content-between position-relative align-items-center">

        <div class="d-flex align-items-center">
          <ng-template [ngTemplateOutlet]="hamburgerMenu"></ng-template>
          <!--        Logo image - XXL screen only-->
          <img src="assets/icons/tracey-alt-logo.svg" alt="Tracey logo"
               [style.width.px]="currentWindowWidth < 1400 ? 132 : 200" (click)="onClickToLogoImage()"
               class="cursor-pointer">

        </div>

        <div class="d-flex align-items-center">
          <!--        Logged out - menu - XXL screen only-->
          <ul
            class="nav nav-alt col-12 col-xxl-auto justify-content-start mb-md-0 d-none d-xxl-flex align-items-center p-0">
            <li [class.active]="activeRoute === EVENT_CALENDAR_ROUTE"><a (click)="onEventCalendar()">{{
                t(
                  'page.header.event.calendar')
              }}</a></li>
            <li [class.active]="activeRoute === FINISHED_EVENTS_ROUTE"><a (click)="goToFinished()">{{
                t(
                  'page.header.finished.events')
              }}</a></li>
            <li [class.active]="activeRoute === LIVE_RESULTS"><a (click)="goToLiveResults()">{{
                t(
                  'page.header.live.results')
              }}</a></li>
            @if (environment.isLeagueVisible) {
              <li [class.active]="activeRoute === SERIES_ROUTE"><a (click)="goToSeries()">{{
                  t(
                    'page.header.series')
                }}</a></li>
            }
            @if (authenticationService.isAuthenticated()) {
              <!--<li [class.active]="activeRoute === MY_TRACEY">
                <a (click)="goToMyTracey()">{{
                    t('app.common.myTracey')
                  }}
                </a>
              </li>-->
              <li (click)="onOrganiserButtonClick()">
                <a>
                  {{
                    t('page.header.organisers')
                  }}
                </a>
              </li>
            }
          </ul>
        </div>

        <div class="d-flex align-items-center">
          <div class="d-none d-xxl-flex pe-3">
            <div class="d-flex align-items-center cursor-ponter" (click)="openLanguagesModal()">
              <i class="bi bi-globe2 me-2 color-white"></i>
              <p class="small text-white">{{ activeLang }}</p>
            </div>
          </div>
          @if (authenticationService.isAuthenticated()) {
            <!--            <div class="d-none d-xxl-flex">-->
              <!--              <ng-container *ngTemplateOutlet="messageIcon; context: { unreadMessages: unreadMessages }"></ng-container>-->
              <!--            </div>-->
            <div class="d-none d-xxl-flex remove-dropdown-icon" ngbDropdown>
              <button type="button" class="btn p-0" id="myProfileDropdown" ngbDropdownToggle>
                <ng-template [ngTemplateOutlet]="avatar"
                             [ngTemplateOutletContext]="{ showName: false, redBorder: true, showArrow: true,
                             initialsBackground: 'var(--slate-950)', initialsColor: 'white' }"></ng-template>
              </button>
            <div ngbDropdownMenu aria-labelledby="myProfileDropdown">
              <div class="px-16 py-14">
                <ng-template [ngTemplateOutlet]="avatar" [ngTemplateOutletContext]="{ showName: true, size: 'xs' }"></ng-template>
              </div>
              <div class="horizontal-line"></div>

              <button ngbDropdownItem (click)="goToMyTracey()">{{ t('app.user.my.tracy') }}</button>
              <button ngbDropdownItem (click)="goToEditProfile()">{{ t('app.user.profile.settings') }}</button>

              <div class="horizontal-line"></div>
              <div class="d-flex align-items-center px-16 py-14 cursor-pointer" (click)="logout()">
                <div class="logout-bg">
                  <img src="assets/img/svg/log-out-alt.svg" alt="Menu" height="18" width="18">
                </div>
                <li [class.active]="activeRoute === SIGNUP_ROUTE" class="m-0 ps-2 fs-14 color-slate-600">{{ t('app.common.logout') }}</li>
              </div>
            </div>
            </div>
          } @else {
            <div class="d-flex flex-xxl-grow-0 ps-4 ps-xxl-0 flex-grow-1 align-items-star">
              <div class="d-flex flex-column d-none d-xxl-flex">
                <div class="d-flex flex-row align-items-center translate-icons">
                  @if (!authenticationService.isAuthenticated()) {
                    <div class="pe-3">
                      <app-button-alt [buttonColor]="'var(--red-brand-color-500)'"
                                      [borderColor]="'var(--red-brand-color-500)'"
                                      [textColor]="'var(--grey-neutral-50)'" [text]="t('app.common.signup')"
                                      (onClickCallback)="goToSignup()" [buttonHeight]="'48px'"></app-button-alt>
                    </div>
                  }

                  <app-button-alt [buttonColor]="'var(--slate-950)'" [borderColor]="'var(--red-brand-color-500)'"
                                  [textColor]="'var(--grey-neutral-50)'" [text]="t('app.common.login')"
                                  (onClickCallback)="goToLogin()" [buttonHeight]="'48px'"></app-button-alt>
                </div>
              </div>
            </div>
          }
        </div>
        <!-- SM screen only-->
          <div class="d-xxl-none d-flex align-items-center gap-3">
            <div class="cursor-pointer d-flex" (click)="toggleSearch()">
              <img src="assets/img/svg/search-icon-alt.svg" alt="Menu">
            </div>
            <div class="pe-2">
              <div class="d-flex align-items-center gap-1 cursor-pointer" (click)="openLanguagesModal()">
                <p class="small text-white">{{ activeLang }}</p>
                <i class="fs-12 fas fa-chevron-down color-white"></i>
              </div>
            </div>
            @if (authenticationService.isAuthenticated()) {
              <div class="remove-dropdown-icon" ngbDropdown placement="bottom-right">
                <div class="d-flex align-items-center cursor-pointer" ngbDropdownToggle>
                  <ng-template [ngTemplateOutlet]="avatar"
                               [ngTemplateOutletContext]="{ showName: false, redBorder: true, showArrow: true,
                               initialsBackground: 'var(--slate-950)', initialsColor: 'white', size: 'sm' }"></ng-template>
                </div>
                <div ngbDropdownMenu aria-labelledby="mobileProfileDropdown">
                  <div class="px-16 py-14">
                    <ng-template [ngTemplateOutlet]="avatar" [ngTemplateOutletContext]="{ showName: true, size: 'xs' }"></ng-template>
                  </div>
                  <div class="horizontal-line"></div>

                  <button ngbDropdownItem (click)="goToMyTracey()">{{ t('app.user.my.tracy') }}</button>
                  <button ngbDropdownItem (click)="goToEditProfile()">{{ t('app.user.profile.settings') }}</button>

                  <div class="horizontal-line"></div>
                  <div class="d-flex align-items-center px-16 py-14" (click)="logout()">
                    <div class="logout-bg">
                      <img src="assets/img/svg/log-out-alt.svg" alt="Menu" height="18" width="18">
                    </div>
                    <li [class.active]="activeRoute === SIGNUP_ROUTE" class="m-0 ps-2 fs-14 color-slate-600">{{ t('app.common.logout') }}</li>
                  </div>
                </div>
              </div>
            }
            <!--            @if (authenticationService.isAuthenticated()) {-->
            <!--              <ng-container *ngTemplateOutlet="messageIcon; context: { unreadMessages: unreadMessages }"></ng-container>-->
            <!--            }-->
          </div>

      </div>
    </div>
  </header>

  <div class="mobile-menu-overlay d-xxl-none"
       [class.mobile-menu-overlay--visible]="isMobileMenuVisible"
       (click)="toggleMobileMenuVisibility()">
  </div>

  <!--   Mobile menu - SM screen only-->
  <div class="slide-in-element d-xxl-none"
       [ngClass]="{'slide-in-element--with-banner': isTopBannerVisible,'slide-in-element--landing': isLanding}"
       [@slideInOut]="isMobileMenuVisible ? (isLanding ? 'inLanding' : 'in') : 'out'">

    <!-- Mobile menu header -->
    <div class="d-flex align-items-center justify-content-between px-3 mobile-menu-top-header"
         style="height: var(--header-height); background: var(--grey-1000);">
      <img src="assets/icons/tracey-alt-logo.svg" alt="Tracey logo" width="132">
      <img src="assets/img/svg/close.svg" alt="Close"
           (click)="toggleMobileMenuVisibility()"
           style="filter: brightness(0) invert(1);" width="24" height="24">
    </div>

    <div class="d-flex justify-content-between align-items-center grey-neutral-50-bg mobile-menu-header position-relative">
      <div class="d-flex align-items-center gap-2 flex-wrap">
        @if (!authenticationService.isAuthenticated()) {
          <app-button-alt [buttonColor]="'white'" [borderColor]="'var(--slate-800)'"
                            [textColor]="'var(--slate-800)'" [fontSize]="'13px'" [minWidth]="'120px'"
                            [text]="t('app.common.login')" (onClickCallback)="goToLogin()" [isFullWidth]="true"
                            [buttonHeight]="'44px'" [textTransform]="'uppercase'" [additionalClass]="'p-10'"></app-button-alt>
          <app-button-alt [buttonColor]="'var(--red-brand-color-500)'"
                          [borderColor]="'var(--red-brand-color-500)'"
                          [fontSize]="'13px'" [additionalClass]="'p-10'" [isFullWidth]="true"
                          [textColor]="'var(--grey-neutral-50)'" [text]="t('app.common.signup')" [minWidth]="'120px'"
                          (onClickCallback)="goToSignup()" [buttonHeight]="'44px'" [textTransform]="'uppercase'"></app-button-alt>
        } @else {
          <ng-template [ngTemplateOutlet]="avatar"></ng-template>
        }
      </div>
    </div>

    <ul class="navigation-mobile d-flex flex-column" [class.landing]="isLanding">

      <li (click)="onClickToLogoImage()" [class.active]="activeRoute === LANDING_ROUTE">
        {{ t('page.header.home') }}
      </li>

      <li (click)="onEventCalendar()" [class.active]="activeRoute === EVENT_CALENDAR_ROUTE">{{
          t('page.header.event.calendar')
        }}
      </li>
      <li (click)="goToFinished()" [class.active]="activeRoute === FINISHED_EVENTS_ROUTE">{{
          t('page.header.finished.events')
        }}
      </li>
      <li (click)="goToLiveResults()" [class.active]="activeRoute === LIVE_RESULTS">{{
          t('page.header.live.results')
        }}
      </li>
      @if (environment.isLeagueVisible) {
        <li [class.active]="activeRoute === SERIES_ROUTE" (click)="goToSeries()">{{
            t('page.header.series')
          }}
        </li>
      }
      @if (authenticationService.isAuthenticated()) {
        <li [class.active]="activeRoute === MY_TRACEY_EDIT" (click)="goToEditProfile()">
          {{ t('app.user.profile.settings') }}
        </li>
        <!--<li (click)="goToMyTracey()" [class.active]="activeRoute === MY_TRACEY">{{
            t('app.common.myTracey')
          }}
        </li>-->
        <!--<li (click)="goToOrders()" [class.active]="activeRoute === MY_TRACEY_ORDERS">{{
            t('app.user.my.tracy.orders')
          }}
        </li>-->
        <li (click)="onOrganiserButtonClick()">{{
            t('page.header.organisers')
          }}
        </li>
      }
      <div class="horizontal-line my-1 w-100"></div>
      <li class="text-capitalize" (click)="toggleLegal()" [style.width]="'inherit'">
        <div class="d-flex align-items-center justify-content-between w-100">
            <div>{{t('app.common.legal.documents')}}</div>
            <i class="ms-2 fs-12 fas" [class.fa-chevron-down]="!isLegalOpen" [class.fa-chevron-up]="isLegalOpen"></i>
          </div>
      </li>
      <li *ngIf="isLegalOpen" class="py-0">
       <div>
        <ul class="navigation-mobile d-flex flex-column my-0 mx-0 px-0 py-0">
              <li  [class.active]="activeRoute === GENERAL_CONDITIONS_ROUTE" (click)="goToPrivacy(GENERAL_CONDITIONS_ROUTE)">
                  {{t("policy.general.conditions")}}
              </li>
              <li [class.active]="activeRoute === PERSONAL_DATA_PROTECTION" (click)="goToPrivacy(PERSONAL_DATA_PROTECTION)">
                    {{t("policy.notice.on.personal.data.protection")}}
              </li>
              <li [class.active]="activeRoute === INTELLECTUAL_PROPERTY_ROUTE" (click)="goToPrivacy(INTELLECTUAL_PROPERTY_ROUTE)">
                   {{t("policy.intellectual.property")}}
              </li>
              <li [class.active]="activeRoute === COMPLAINTS_AND_DISPUTES" (click)="goToPrivacy(COMPLAINTS_AND_DISPUTES)">
                {{t("policy.complaints.and.disputes")}}
              </li>
          </ul>
        </div>
       </li>
      <li (click)="goToPrivacy(COOKIE_POLICY_ROUTE)" class="text-capitalize" [class.active]="activeRoute === COOKIE_POLICY_ROUTE">{{
      t("policy.cookie")
      }}
      </li>
      <li (click)="goToContact()" class="text-capitalize" [class.active]="activeRoute === CONTACT_ROUTE">{{
      t('footer.about.contact')
      }}
      </li>
      @if (authenticationService.isAuthenticated()) {
        <div class="horizontal-line my-1 w-100"></div>
        <div class="d-flex align-items-center px-20" (click)="logout()">
          <img src="assets/img/svg/log-out-alt.svg" alt="Menu" height="24" width="24">
          <li [class.active]="activeRoute === SIGNUP_ROUTE" class="m-0 ps-2">{{ t('app.common.logout') }}</li>
        </div>
      }
    </ul>
  </div>

  <ng-template #hamburgerMenu>
    <div class="hamburger-button d-flex align-items-center justify-content-start d-xxl-none" (click)="toggleMobileMenuVisibility()">
      <img src="assets/img/svg/menu-icon-alt.svg" alt="Menu">
    </div>
  </ng-template>

  <ng-template #avatar
               let-showName="showName" let-size="size"
               let-redBorder="redBorder" let-nameFontSize="nameFontSize"
               let-initialsBackground="initialsBackground" let-initialsColor="initialsColor"
               let-showArrow="showArrow">
    <div class="profile-box"
         [class.profile-box--sm]="size === 'sm'"
         [class.profile-box--xs]="size === 'xs'">
      @if (currentUserDetails?.picture) {
        <div class="d-flex flex-row align-items-center">
          <div class="pe-2">
            <div class="avatar-arrow-down">
              <img [src]="currentUserDetails!.picture" class="avatar" alt="Avatar"/>
              <img *ngIf="showArrow === true" src="assets/img/svg/arrow-down.svg" alt="Arrow down" class="cursor-pointer arrow-down">
            </div>
          </div>
          <div *ngIf="showName !== false">
            <p class="fw-semibold text-capitalize" [style.font-size]="nameFontSize">{{ currentUserDetails?.firstname }} {{
                currentUserDetails?.lastname
              }}</p>
          </div>
        </div>
      } @else {
        <div class="d-flex flex-row align-items-center">
          <div class="avatar-arrow-down me-2">
            <div class="profile-box__initials d-flex align-items-center justify-content-center"
                 [class.profile-box__initials--sm]="size === 'sm'"
                 [class.profile-box__initials--xs]="size === 'xs'"
                 [class.red-border]="redBorder === true"
                 [style.background-color]="initialsBackground">
              <p [style.color]="initialsColor ? initialsColor : 'var(--slate-800)'">
                {{ currentUserDetails?.firstname?.charAt(0)?.toUpperCase() }}{{ currentUserDetails?.lastname?.charAt(0)?.toUpperCase() }}
              </p>
            </div>
            <div *ngIf="showArrow === true" class="arrow-background">
              <img src="assets/img/svg/arrow-down.svg" alt="Arrow down" class="cursor-pointer arrow-down">
            </div>
          </div>
          <div *ngIf="showName !== false">
            <p class="fw-semibold text-capitalize" [style.font-size]="nameFontSize">
              {{ currentUserDetails?.firstname }} {{ currentUserDetails?.lastname }}
            </p>
          </div>
        </div>
      }
    </div>
  </ng-template>

</ng-container>

<ng-template #messageIcon let-unreadMessages="unreadMessages">
  <div class="d-flex align-items-center">
    <div class="pe-3">
      <ng-container *ngIf="(unreadMessages?.length ?? 0) > 0; else readIcon">
        <div class="unread-msg-circle-alt" (click)="goToMessages(false)">
          <img src="assets/icons/notification-unread.svg" alt="Unread Messages" [style.height]="'24px'"
               class="cursor-pointer">
        </div>
      </ng-container>
      <ng-template #readIcon>
        <div (click)="goToMessages(true)">
          <img src="assets/icons/notification-read.svg" alt="Messages" [style.height]="'24px'" class="cursor-pointer">
        </div>
      </ng-template>
    </div>
  </div>
</ng-template>

